import {observer} from "mobx-react";
import {ConfirmModalDialog, Page, PageContentTitle, Pager, ScrollTable, Searchbar} from "../../ui";
import {
    authStore,
    DialogStore,
    pageQueryStore,
    scanCustomerStore,
    ScanDocumentDialogStore,
    seaDocumentArchiveStore,
    seaDocumentDetailStore,
    seaDocumentListStore
} from "../../../store";
import {useEffect, useState} from "react";
import {ExpandableRow} from "./ExpandableRow";
import {useSearchParams} from "react-router";
import {Filterbar} from "./Filterbar";
import {ScanDocumentDialog} from "./scan";

function Button({
                    action,
                    disabled,
                    label,
                    icon
                }: {
    action: () => any,
    disabled?: boolean
    label: string
    icon: string
}) {
    return <button
        className={"button is-rounded is-primary"}
        style={{marginLeft: '1em'}}
        disabled={disabled}
        onClick={() => action()}>
                    <span className="icon is-small">
                        <span className="material-symbols-outlined">{icon}</span>
                    </span>
        <span>{label}</span>
    </button>
}

const PageActions = observer(function PageAction() {
    const [searchParams, setSearchParams] = useSearchParams()
    const [scanDialogStore] = useState(new ScanDocumentDialogStore())
    const [archiveDialogStore] = useState(new DialogStore())

    return <>
        <ScanDocumentDialog
            store={scanDialogStore}
        />
        <ConfirmModalDialog
            store={archiveDialogStore}
            title={"Archivieren"}
            label={"Jetzt archivieren"}
            message={`Sollen wirklich ${seaDocumentArchiveStore.count} Dokumente unwiderruflich archiviert werden?`}
            execute={async () => {
                await seaDocumentArchiveStore.archive()
                searchParams.set('page', '1')
                setSearchParams(searchParams)
            }}
        />
        {authStore.hasRole('SCAN_ADAPTER_WRITE') && <Button
            label={'Fahrzeug Scan erfassen'}
            action={() => {
                scanDialogStore.dialogOpen = true
                scanCustomerStore.load().finally()
            }}
            icon={'document_scanner'}/>}

        {authStore.hasRole('SCAN_ADAPTER_ARCHIVE_DOCUMENT') && <Button
            label={'Archivieren'}
            disabled={seaDocumentArchiveStore.isEmpty || seaDocumentArchiveStore.executing}
            action={() => {
                archiveDialogStore.dialogOpen = true
            }}
            icon={'archive'}/>}
    </>
})

const SeaDocumentListPage = observer(function SeaDocumentListPage() {
    const [expandedRow, setExpandedRow] = useState<string | undefined>()
    const [searchParams, setSearchParams] = useSearchParams()

    useEffect(() => {
        pageQueryStore.restore('sea', searchParams, setSearchParams)
    }, [searchParams, setSearchParams])

    return <Page
        breadcrumb={[
            {
                link: '/sea/document',
                label: `Scandatenimport`
            }
        ]}
        action={<PageActions/>}
    >
        <PageContentTitle
            actionItem={<>
                <Filterbar/>
            </>}
        >
            <Searchbar placeholder={"FIN, Scancode oder Akte"}/>
        </PageContentTitle>
        <ScrollTable>
            <thead>
            <tr>
                {authStore.hasRole('SCAN_ADAPTER_ARCHIVE_DOCUMENT') && <th style={{width: '2.5em'}}></th>}
                <th>Eingangsdatum</th>
                <th>Stapel</th>
                <th>Akte</th>
                <th>Dokument</th>
                <th>Scancode</th>
                <th>FIN</th>
                <th>Dokumentenart</th>
                <th>Position</th>
                <th>Stapel-Status</th>
            </tr>
            </thead>
            <tbody>
            {seaDocumentListStore.items.map((val, index) => {
                return <ExpandableRow
                    item={val} key={index}
                    expanded={val.id === expandedRow}
                    onClick={() => {
                        const id = val.id
                        if (val.id !== expandedRow && id) {
                            seaDocumentDetailStore.load(id).finally()
                        }
                        setExpandedRow(id === expandedRow ? undefined : id)
                    }}
                />
            })}
            </tbody>
        </ScrollTable>
        <Pager total={seaDocumentListStore.pages}/>
    </Page>
})

export {
    SeaDocumentListPage
}
